// Regra unica de acesso a uma "tela interna" (estatica/built/personalizado) por setor/usuario.
// Suporta MULTISELECAO de setores (campo `setores: []`) com fallback ao `setor` (single, legado).
// TI e Administrador sempre passam.
export function setoresLiberados(tela) {
    if (!tela) return [];
    if (Array.isArray(tela.setores) && tela.setores.length) return tela.setores;
    if (tela.setor) return [tela.setor];
    return [];
}

// Conta RESTRITA (TI > Logins > "Acesso restrito"): so ve o que foi liberado a ela pelo NOME. Nao vale para TI nem Administrador.
export function ehRestrito(user) {
    return !!user && !!user.restrito && user.cargo !== 'Administrador' && user.setor !== 'TI';
}

export function podeAcessarTela(user, tela) {
    if (!user) return false;
    if (user.cargo === 'Administrador' || user.setor === 'TI') return true;
    // restrita: nem pagina de "todos" nem a do setor abrem; so a que lista o usuario em `usuarios`
    if (ehRestrito(user)) return !!tela && (tela.usuarios || []).includes(user.id);
    const modo = (tela && tela.modo_acesso) || 'todos';
    if (modo === 'todos') return true;
    if (modo === 'setor') return setoresLiberados(tela).includes(user.setor) || (tela.usuarios || []).includes(user.id);
    if (modo === 'usuarios') return (tela.usuarios || []).includes(user.id);
    return true;
}
